import React from 'react';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import { formatDate, formatCurrency } from '../../../lib/utils';
import { TransactionTypes } from '../../../lib/constants';

export default class AllTransactionsTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.formatAmount = this.formatAmount.bind(this);
    }

    getTableRow(transaction) {
        return (
          <HoverTableRow
            key={transaction.transactionId}
            className="table-row"
            onDoubleClick={() =>
              transaction.recipientId &&
              transaction.applicationId &&
              window.open(
                `/recipient-accounts/${transaction.recipientId}?applicationId=${transaction.applicationId}`,
                "_blank"
              )
            }
          >
            <td data-label="ReferenceNum" key="ReferenceNum">
              <p>{transaction.referenceNumber}</p>
            </td>
            <td data-label="Status" key="Status">
              <p>{transaction.status}</p>
            </td>
            <td data-label="Date" key="Date">
              <p>{formatDate(transaction.date)}</p>
            </td>
            <td data-label="Amount" key="Amount">
              {this.formatAmount(transaction.type, transaction.amount)}
            </td>
            <td data-label="Details" key="Details">
              <p>{transaction.details}</p>
            </td>
            {this.props.canUpdate && (
              <td
                data-label="Action"
                style={{ maxWidth: "150px" }}
                key="Action"
              >
                <div className="transactions-table-actions flex flex-justify">
                  {!!transaction.reconciliationId && (
                    <span
                      className="link-text small-text text-center input ml-8"
                      onClick={() =>
                        this.props.onUpdateReconciliationStatus(transaction)
                      }
                    >
                      Change Reconciliation Status
                    </span>
                  )}
                  {!!transaction.reconciliationNote && (
                    <span
                      className="link-text small-text text-center input ml-8"
                      onClick={() =>
                        this.props.onClickReconciliationNote(transaction)
                      }
                    >
                      Note
                    </span>
                  )}
                </div>
              </td>
            )}
          </HoverTableRow>
        );
    }

    formatAmount(type, amount) {
        return type === TransactionTypes.Withdrawal ? <p className="error-text">-{formatCurrency(amount, this.props.isIsraeli)}</p>
            : <p className="approved-text">+{formatCurrency(amount, this.props.isIsraeli)}</p>
    }

    render() {
        const columns = [
            { title: 'Reference #', sortable: true, id: 'reference'},
            { title: 'Status', sortable: true, id: 'status'},
            { title: 'Date', sortable: true, id: 'date', defaultDirection: 'Descending'},
            { title: 'Amount', sortable: true, id: 'amount'},
            { title: 'Details', sortable: false, id: 'details'}
        ];
        
        if(this.props.canUpdate) {
            columns.push({ title: 'Action', sortable: false, id: 'action'});
        }

        return (
          <PaginatedTable
            name="transactions"
            page={this.props.page}
            totalCount={this.props.data.totalCount}
            resultsView={this.props.resultsView}
            sort={this.props.sort}
            loading={this.props.loading}
            success={this.props.success}
            renderRow={this.getTableRow.bind(this)}
            columns={columns}
            records={this.props.data.records || []}
            sortData={this.props.updateTable}
            changeDataView={this.props.updateTable}
            loadData={this.props.getTransactions}
          />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/AllTransactionsTable.jsx